export default "__VITE_ASSET__CLMT$4qE__"